import React from "react";
import {DatePicker} from "rsuite";

export default ({isMobile, ...props}) => {
    return (
        <DatePicker {...props}/>
    )
};